@switch (viewState$ | async) {
  @case (redirectionViewStateEnum.Loading) {
    <app-loading-animation width="270px" height="270px"></app-loading-animation>
  }

  @case (redirectionViewStateEnum.Failed) {
    <app-invalid-link></app-invalid-link>
  }
}
